<template>
	<component :is="tag" v-bind="attributes"><component :is="componentOfPart(itemPart)" :part="partRef(itemPart)" :data="object" :readonly="readonly"></component></component>
</template>

<script setup lang="ts">
import {ref, computed, type CSSProperties} from "vue";
import type {CellBinding} from "@fd/containers/agenda/AgendaUtils.ts";
import {injectComponentOfPart, injectPartRef} from "@fd/PartInjectKeys.ts";
import {ItemsGrid} from "@t/fd/layout/Items.ts";
import type {FormPartOrReference} from "@t/fd/FormPartOrReference.ts";

const props = withDefaults(defineProps<{
	object: object,
	grid: ItemsGrid,
	tag?: string,
	readonly?: boolean
}>(), { tag: "td", readonly: false });

const partRef = injectPartRef();
const componentOfPart = injectComponentOfPart();

const itemPart = computed<FormPartOrReference>(() => props.grid.item);

const attributes = computed<CellBinding|null>(() => {
	const bind:CellBinding = {};
	return bind;
});

</script>

<style>

</style>